import React, { useEffect, useState } from 'react';
import { getBindableBrand, getBrandListByIds } from '../../services/brandService';
import { postImage, postCategory } from '../../services/frontCategoryService';
import { Form, Input, Select, Modal, Upload, message, DatePicker, Radio } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import _ from 'lodash';
import moment from 'moment';
import './category-modal.scss';
const { RangePicker } = DatePicker;

const { Option } = Select;

function FirstModal(props) {
    const { onClose, visible, current, parentId, handleSuccess } = props || {};
    const { id, activities } = current || {};
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const [brand, setBrand] = useState([]);
    const [banner, setBanner]: any = useState(activities?.[0]?.banner || null);
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 6 }
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 }
        }
    };

    useEffect(() => {
        if(current?.brandIds && current?.brandIds?.length) {
            getBrandListByIds(current?.brandIds)
                .then(res => {
                    setBrand(res.data.brands || []);
                })
        }
    }, [current]);

    function handleSubmit() {
        form.validateFields()
            .then(values => {
                if(submitting) return null;
                setSubmitting(true);
                const data = {
                    ...values,
                    id: id || null,
                    parentId: parentId || current?.parentId,
                    priority: current?.priority || 0,
                    activities: [{
                        ...values.activities,
                        banner,
                        validAt: values?.time?.[0] ? Number(moment(values?.time?.[0]).format('x')) : null,
                        expiresAt: values?.time?.[1] ? Number(moment(values?.time?.[1]).format('x')) : null
                    }]
                }
                delete data.time;
                postCategory(data)
                    .then(res => {
                        setSubmitting(false);
                        message.success('保存成功');
                        handleSuccess && handleSuccess();
                        onClose && onClose();
                    }).catch(err => {
                        setSubmitting(false);
                    })
            })
    }

    useEffect(() => {
        if(current) {
            const { validAt, expiresAt } = current?.activities?.[0] || {};
            const data = {
                ...current,
                activities: current?.activities?.[0] || {},
                time: validAt && expiresAt ? [moment(validAt), moment(expiresAt)] : []
            }
            form.setFieldsValue(data);
        }
    }, [current]);

    function getBrandOption(keyword = '') {
        getBindableBrand(keyword).then(res => {
            setBrand(res.data.brands || []);
        });
    }

    function handleSearch(value) {
        setBrand([]);
        if(!value) return null;
        getBrandOption(value);
    }

    function uploadImage(data) {
        const file = data.file;
        let format = file.type.split('/')[1];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (evt) {
          // 创建image对象
          let image = new Image();
          image.src = evt?.target?.result as string;
          // 获取图片宽高
          image.onload = function () {
            let formData = new FormData();
            formData.append('image', file)
            postImage('FRONTEND_CATEGORY_ICON', formData)
                .then(res => {
                    const { url, width, height } = res?.data || {};
                    setBanner({
                        url,
                        width,
                        height
                    })
                })
          }
        };
    }

    function handleImgDelete(e) {
        e.stopPropagation();
        setBanner(null);
    }

    return (
        <Modal
            visible={visible}
            okText="保存"
            cancelText="取消"
            onCancel={onClose}
            onOk={handleSubmit}
            destroyOnClose={true}
            confirmLoading={submitting}
            maskClosable={false}
            title="一级类目"
            width={'60%'}
        >
            <Form {...formItemLayout} form={form} initialValues={{status: 'ONLINE'}}>
                <Form.Item
                    label='名称'
                    name='name'
                    rules={[{ required: true, message: '请输入类目名称' }]}
                >
                    <Input allowClear />
                </Form.Item>
                <Form.Item label="关联品牌" name='brandIds'>
                    <Select
                        showSearch
                        allowClear
                        mode="multiple"
                        placeholder="搜索品牌"
                        filterOption={false}
                        autoClearSearchValue={true}
                        onSearch={_.debounce(handleSearch, 300)}
                    >
                        {brand.map((item: any) => {
                            return (
                                <Option key={item?.name} value={item?.id}>{item?.name}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
                <Form.Item label='关联活动' name={['activities', 'deeplink']}>
                    <Input allowClear />
                </Form.Item>
                <Form.Item label='活动时间' name='time'>
                    <RangePicker showTime={true} />
                </Form.Item>
                <Form.Item label='活动banner' name={['activities', 'banner']}>
                    <Upload
                        name='bannerUrl'
                        listType="picture-card"
                        showUploadList={false}
                        customRequest={uploadImage}
                    >
                        {banner?.url ?
                            <div className='img-wrap' style={{position: 'relative'}}>
                                <img src={banner?.url} alt="avatar" style={{ width: '100%' }} />
                                <div className='delete-icon-wrap' onClick={handleImgDelete}>
                                    <MinusCircleOutlined style={{color: '#ffffff'}} />
                                </div>
                            </div> : 
                            <div>
                                上传图片
                            </div>
                        }
                    </Upload>
                </Form.Item>
                <Form.Item label="状态" name='status'>
                    <Radio.Group>
                        <Radio value='ONLINE'>启用</Radio>
                        <Radio value='OFFLINE'>禁用</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default FirstModal;